import { Layout } from 'antd';
import React from 'react';
import AppHeader from '../../../../components/AppHeader';
import ProjectSuccessContent from './ProjectSuccessContent';
import { Product } from '../../../../../data/terra/Product';

interface CreateProjectProps {
  project: Product;
}

const ProjectResultContent: React.FC<CreateProjectProps> = (props) => {
  const { project } = props;

  return (
    <div style={{ width: '100%', height: '100%', background: 'white' }}>
      <Layout className="app-layout-v2">
        <AppHeader />
        <div style={{ height: '64px' }} />
        <ProjectSuccessContent project={project} />
      </Layout>
    </div>
  );
};

export default ProjectResultContent;
